import React from 'react';
import clsx from 'clsx';

export default function Card({
  children,
  className,
  padding = true,
  hover = false,
  onClick,
  ...props
}) {
  return (
    <div
      className={clsx(
        'bg-bg-secondary border border-border rounded-xl',
        padding && 'p-6',
        hover && 'hover:border-border-light transition-colors duration-200 cursor-pointer',
        onClick && 'cursor-pointer',
        className
      )}
      onClick={onClick}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardHeader({ children, className }) {
  return (
    <div className={clsx('mb-4', className)}>
      {children}
    </div>
  );
}

export function CardTitle({ children, className }) {
  return (
    <h3 className={clsx('text-lg font-semibold text-text-primary', className)}>
      {children}
    </h3>
  );
}

export function CardContent({ children, className }) {
  return (
    <div className={clsx(className)}>
      {children}
    </div>
  );
}
